import React from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import get from 'lodash/get';
import moment from 'moment';

import {
  Author,
  TrendingNewsCardContainer,
  TrendingNewsImage,
  CardImage,
  CardContent,
} from './trendingNewsCard.styled';
import StaticPicture from '../StaticImage';
import Image1 from '../../images/1366x768.jpg';

const TrendingNewsCard = ({ ID, page }) => {
  const data = useStaticQuery(graphql`
  query newsListingQueryAndNewsListingQuery {
    allWpPost(sort: { date: DESC }) {
      nodes {
        title
        id
        slug
        databaseId
        postsFields {
          author {
            name
            id
            slug
          }
        }
        date
        featuredImage {
          node {
            altText
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 1366
                  height: 768
                  formats: WEBP
                )
              }
            }
          }
        }
      }
    }
    allWpPolicy(sort: { date: DESC }) {
      nodes {
        author {
          node {
            name
            slug
          }
        }
        title
        id
        slug
        databaseId
        date
        featuredImage {
          node {
            altText
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 1366
                  height: 768
                  formats: WEBP
                )
              }
            }
          }
        }
      }
    }
  }
  `);

  const list =
    page === 'policy'
      ? get(data, 'allWpPolicy.nodes')
      : get(data, 'allWpPost.nodes');
  const json = list.filter((x) => x.databaseId === ID);
  const title = json.length > 0 ? get(json[0], 'title') : 'Testing';
  const author =
    json.length > 0 ? get(json[0], 'author.node.name') : 'Testing';
  const authorSlug =
    json.length > 0 ? get(json[0], 'author.node.slug') : 'Testing';
  const date = json.length > 0 ? moment(get(json[0], 'date')).format('MMMM D, YYYY') : 'Testing';
  const slug = json.length > 0 ? get(json[0], 'slug') : '';
  const authorNames =
    json.length > 0 ? get(json[0], 'postsFields.author') : null;
  const image =
    json.length > 0
      ? get(json[0], 'featuredImage.node.mediaItemUrl')
      : Image1;

  const optimizeImage =
    json.length > 0 && get(json[0], 'featuredImage.node.localFile');
  return (
    <TrendingNewsCardContainer data-testid='trending-container'>
      <div className='card-content'>
        <CardImage
          to={
            page === 'policy'
              ? `/policies-and-actions/${slug}/`
              : `/news/${slug}/`
          }
        >
          <TrendingNewsImage>
            {optimizeImage ? (
              <GatsbyImage image={getImage(optimizeImage)} alt={title} />
            ) : (
              <StaticPicture imgFile={image} altText={title} size='s' />
            )}
          </TrendingNewsImage>
        </CardImage>
        <CardContent>
          <Link
            to={
              page === 'policy'
                ? `/policies-and-actions/${slug}/`
                : `/news/${slug}/`
            }
            className='content'
            title={title}
          >
            {title}
          </Link>
          <Author>
            {author && (
              <Link to={`/author/${authorSlug}/`} className='author-container' title={author}>
                <span>{author}</span>
              </Link>
            )}
            {authorNames &&
              Array.isArray(authorNames) &&
              authorNames.map((value, index) => (
                <span className='author-container' key={index}>
                  <Link
                    to={`/author/${value.slug}/`}
                    className='author-name'
                    title={value.name}
                  >
                    {value.name}
                  </Link>
                  {index !== authorNames.length - 1 && `, `}
                </span>
              ))}
            {((authorNames && Array.isArray(authorNames) && authorNames.length > 0) || author) && date && <span className='divider' />}
            {date && <span>{date}</span>}
          </Author>
        </CardContent>
      </div>
    </TrendingNewsCardContainer>
  );
};

export default TrendingNewsCard;
